import React from "react";
import SectionSimpleLookup from "./SectionSimpleLookup";

export default function SectionLieferservice({
                                                 form,
                                                 setForm,
                                                 deliveryServices,
                                                 deliveryServicesLoading,
                                                 deliveryServicesError,
                                             }) {
    return (
        <SectionSimpleLookup
            form={form}
            setForm={setForm}
            field="delivery_service_ids"
            items={deliveryServices}
            loading={deliveryServicesLoading}
            error={deliveryServicesError}
            emptyText="Kein Lieferservice vorhanden. Lege zuerst Lieferservice an."
        />
    );
}
